import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip.js';

gsap.registerPlugin(Flip);

export default class Nav {
  constructor(navRoot) {
    this.navRoot = navRoot;
    this.navButton = this.navRoot.querySelector('.js-nav-btn');
	 this.navContent = this.navRoot.querySelector('.js-nav-content');
	 this.isOpen = false;

    this.init();
  }

  init() {
		this.navButton.addEventListener('click', e => {
			const isOpen = this.navButton.getAttribute('aria-expanded') === 'false';

			const navState = Flip.getState(this.navRoot);
			this.navRoot.classList.toggle("is-open", isOpen);

			this.navButton.setAttribute('aria-expanded', isOpen);
			document.body.classList.toggle('has-fixed-menu', isOpen);

			Flip.from(navState, {
				duration: .5,
				ease: "power1.inOut"
			});

			isOpen && gsap.from('.js-nav-list > li', {
				opacity: 0,
				y: -24,
				stagger: 0.1,
				delay: 0.2,
			})
		});
  }
}

